import { useEffect, useState } from 'react';

export interface UseTargetDateProps {
  initialDate?: string | null;
  onDateChange?: (date: Date | null) => void;
}

const createDateWithoutTimezoneIssues = (dateString: string | Date | null): Date | null => {
  if (!dateString) return null;

  const date = new Date(dateString);
  date.setUTCHours(12, 0, 0, 0); // Set the time to noon UTC to avoid any timezone-related date shifting
  return date;
};

export const useTargetDate = ({ initialDate, onDateChange }: UseTargetDateProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    initialDate ? createDateWithoutTimezoneIssues(initialDate) : null
  );

  const handleDateChange = (date: Date | null) => {
    if (date) {
      const adjustedDate = createDateWithoutTimezoneIssues(date);
      setSelectedDate(adjustedDate);
      onDateChange?.(adjustedDate);
    } else {
      setSelectedDate(null);
      onDateChange?.(null);
    }
  };

  useEffect(() => {
    if (initialDate) {
      setSelectedDate(createDateWithoutTimezoneIssues(initialDate));
    }
  }, [initialDate]);

  return {
    selectedDate,
    handleDateChange,
  };
};
